import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BlockedCprService } from '../../services/blocked-cpr.service';

@Component({
  selector: 'app-upload-blocked-cpr',
  templateUrl: './upload-blocked-cpr.component.html',
  styleUrls: ['./upload-blocked-cpr.component.scss']
})
export class UploadBlockedCprComponent {
  selectedFile: File | null = null;
  uploading = false;
  results: any = null;
  errors: string[] = [];
  success = false;
  fileError = '';

  constructor(
    private blockedCprService: BlockedCprService,
    private router: Router
  ) {}

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      // Check if file is a CSV
      if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
        this.fileError = 'Please select a valid CSV file.';
        this.selectedFile = null;
        return;
      }
      
      this.fileError = '';
      this.selectedFile = file;
    }
  }

  onUpload(): void {
    if (!this.selectedFile) {
      this.fileError = 'Please select a CSV file.';
      return;
    }

    this.uploading = true;
    this.success = false;
    this.errors = [];
    
    this.blockedCprService.uploadBlockedCpr(this.selectedFile)
      .subscribe(
        response => {
          this.uploading = false;
          if (response.status) {
            this.results = response.data;
            this.errors = response.data.errors || [];
            
            // Reset file input after successful upload
            if (response.data.success > 0) {
              this.success = true;
              this.selectedFile = null;
              // Reset file input
              const fileInput = document.getElementById('csvFile') as HTMLInputElement;
              if (fileInput) {
                fileInput.value = '';
              }
            }
          } else {
            this.errors = [response.message || 'Failed to upload CPR numbers.'];
          }
        },
        error => {
          this.uploading = false;
          console.error('Error uploading blocked CPR CSV:', error);
          this.errors = [error.error?.message || 'An error occurred while uploading the CSV file.'];
        }
      );
  }

  goBack(): void {
    this.router.navigate(['/blocked-cpr']);
  }
} 